import View from "./View";
import { FileStates } from "./FileModel";

const SpinnerView = View.extend(
  /** @lends SpinnerView.prototype */
  {
    /**
     * View for the uploading / waiting spinner on items.
     * Automatically shows/hides/updates itself based on model state.
     * @param {FileModel} model
     * @param {object} opts
     * @constructs
     * @extends View
     */
    constructor(model, opts) {
      View.call(this, model, opts);

      this.setHTML(this.opts.template.parse("item_progress", { id: this.id }));
    },

    onMount() {
      this.percentageEl = this.getElement("percentage");
      this.progressEl = this.getElement("progress");
      // this.svgPathLen = this.progressEl.getTotalLength(); // doesn't work in FF
      this.svgPathLen = 2 * Math.PI * this.progressEl.getAttribute("r");

      this.listenTo(this.model, "state_changed", ({ state }) => { this.handleStateChange(state); });
      this.listenTo(this.model, "progress", ({ progress }) => { this.handleProgress(progress); });

      if(this.model.state !== FileStates.UPLOADING) this.hide();

      this.handleStateChange(this.model.state);
      this.setProgress(0);
    },

    /**
     * Handle model state change
     * @param {string} state - one of {@link FileStates}
     * @protected
     */
    handleStateChange(state) {
      if(state !== FileStates.PENDING && this.exitPending) this.exitPending();
      switch(state) {
        case FileStates.UPLOADING:
          this.enterUploading();
          break;
        case FileStates.PENDING:
          this.enterPending();
          break;
        default:
          this.hide();
      }
    },

    /** @private */
    enterUploading() {
      this.show();
      this.setText("");

      const lenStr = this.svgPathLen.toFixed(3);
      this.progressEl.setAttribute("stroke-dasharray", `${lenStr} ${lenStr}`);
    },

    /** @private */
    enterPending() {
      this.show();
      this.setText("");

      const len1 = this.svgPathLen / 4;
      const len2 = 3 * len1;
      this.progressEl.setAttribute("stroke-dasharray", len1.toFixed(3) + " " + len2.toFixed(3));

      const speed = 1e-1;
      let start = 0;
      let pendingAnimation;

      const transformStr = this.progressEl.getAttribute("transform");

      const tick = time => {
        pendingAnimation = requestAnimationFrame(tick);
        if(!start) {
          start = time;
          return;
        }
        this.progressEl.setAttribute("transform", transformStr.replace(/rotate\(\d+\)/, `rotate(${((time - start) * speed).toFixed(3)})`));
      };

      pendingAnimation = requestAnimationFrame(tick);

      this.exitPending = () => {
        cancelAnimationFrame(pendingAnimation);
        this.exitPending = null;
        this.progressEl.setAttribute("transform", transformStr);
      };
    },

    /** @private */
    setText(text) {
      this.percentageEl.textContent = text;
    },

    /** @private */
    setProgress(progress) {
      this.progressEl.setAttribute("stroke-dashoffset", ((1 - progress) * this.svgPathLen).toFixed(3));
    },

    /**
     * Handle model upload progress change
     * @protected
     */
    handleProgress(progress) {
      this.setText(Math.round(progress * 100) + "%");
      this.setProgress(progress);
    }
  });

export default SpinnerView;
